import { type AnyFieldMeta } from "@tanstack/react-form";

export function FieldErrors({ meta }: { meta: AnyFieldMeta }) {
  if (!meta.isTouched) return null;
  return meta.errors
    .filter((e) => e != null)
    .map((e) => (
      <p key={e.message} className="text-sm text-destructive">
        {e.message}
      </p>
    ));
}
